import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=ba0531f8"
import script from "./Edit.js?vue&type=script&lang=js&external"
export * from "./Edit.js?vue&type=script&lang=js&external"
import style0 from "./Edit.vue?vue&type=style&index=0&id=ba0531f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports